import React from "react";
import { Button } from "../../../../ui/components/Button";
import {
  getPostedStatusLabel,
  getStoredAccountingBackend,
} from "../../../../config/accounting";
import { CreditNoteListStatus } from "../../domain";

interface CreditNoteStatusFilterPillsProps {
  value: CreditNoteListStatus;
  onChange: (value: CreditNoteListStatus) => void;
}

export const CreditNoteStatusFilterPills: React.FC<
  CreditNoteStatusFilterPillsProps
> = ({ value, onChange }) => {
  const options: Array<{ value: CreditNoteListStatus; label: string }> = [
    { value: "all", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "under_review", label: "Under Review" },
    {
      value: "posted",
      label: getPostedStatusLabel(getStoredAccountingBackend()),
    },
    { value: "rejected", label: "Rejected" },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2">
      {options.map((option) => (
        <Button
          key={option.value}
          variant={value === option.value ? "brand-primary" : "neutral-secondary"}
          size="small"
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};
